import React from 'react';

export default function OAuthError() {
  const params = new URLSearchParams(window.location.search);
  const error = params.get('error');

  return (
    <div className="max-w-2xl mx-auto p-6 mt-12">
      <div className="bg-red-50 border border-red-200 rounded-lg p-8 text-center">
        <div className="text-6xl mb-4">❌</div>
        <h1 className="text-2xl font-bold text-red-900 mb-2">
          Authentication Failed
        </h1>
        <p className="text-red-700 mb-4">
          {error || 'An error occurred during authentication'}
        </p>
        <button
          onClick={() => window.location.href = '/'}
          className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
        >
          Return Home
        </button>
      </div>
    </div>
  );
}